import { useState } from 'react';

export interface PreviewImage {
  id: number;
  item_id: number;
  zipline_url: string;
  created_at: string;
}

interface PendingImage {
  url: string;
  ziplineId: string | undefined;
}

export function usePendingImages() {
  const [pending, setPending] = useState<PendingImage[]>([]);

  const pendingImageUrls = pending.map((p) => p.url);

  const previewImages: PreviewImage[] = pending.map((p, i) => ({
    id: -(i + 1),
    item_id: 0,
    zipline_url: p.url,
    created_at: new Date().toISOString(),
  }));

  function addImage(url: string, ziplineId?: string) {
    setPending((prev) => [...prev, { url, ziplineId }]);
  }

  function deleteImage(fakeId: number) {
    const idx = -fakeId - 1;
    setPending((prev) => prev.filter((_, i) => i !== idx));
  }

  return { pending, pendingImageUrls, previewImages, addImage, deleteImage };
}
